import script from "./CreateBatch.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateBatch.vue?vue&type=script&setup=true&lang=ts"

import "./CreateBatch.vue?vue&type=style&index=0&id=52084dc4&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52084dc4"]])

export default __exports__